import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicProofTechniques = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Proof Techniques"
      videos={[
        "https://www.youtube.com/embed/V5tUc-J124s", // All proof techniques in a single video
        "https://www.youtube.com/embed/x-42XV5LlHg", // Deductive proof
        "https://www.youtube.com/embed/7zOBE8lKhis", // Inductive proof
      ]}
      takeaways={[
        { text: "Inductive proof is much more important than other types." },
        { text: "Practice questions that involve inductive proof of grammar rules (this is a bit tricky)." },
        { text: "Inductive proof of mathematical formulas is easier compared to other types." },
        { text: "Mostly, the examples mentioned in the teacher's PPTs come directly in the exam." },
      ]}
      questions={[
        {text:"Explain the steps involved in an inductive proof with an example."},
        {text:"Compare and contrast deductive and inductive proof techniques."},
        {text:"Prove a given mathematical formula using inductive proof."},
        {text:"Practice inductive proof of grammar rules (e.g., prove that a given grammar generates a specific language)."},
      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicProofTechniques };